// Modal loader removed per user request in favor of inline skeleton shimmer loaders on data tables
function Loader() {
  return null;
}

export default Loader;
